<template lang="pug">
  .reference-layers
    h4.heading
      span Select layers:
      a.legend(@click="toggleLegend") VIEW LEGEND
    .layerList
      v-checkbox(
        color="primary"
        :label="layer.name"
        :key="layer.name"
        v-model="layer.visible"
        v-for="layer in vectorLayers"
        @change="toggleLayer(layer.name)"
        :height="`${layer.name.length <= 33 ? '.5em' : 'auto'}`"
      )
    .spacer
    v-alert.transparency-alert(color="grey lighten-3" :value="true")
      h4 Adjust Reference Transparency:
      v-slider(v-model="transparency" step="1" max="100" min="0" thumb-label @input="onOpacityChange")
    v-btn(
          class="black--text"
          block
          color="secondary"
          target="_blank"
          href="https://help.coloradoforestatlas.org/public/reference-layers-descriptions"
          slot="activator")
          v-icon(left) info
          | VIEW LAYER DESCRIPTIONS
</template>

<script>

import { toggleLayer, setOpacity, getMap, toggleLegend } from '@/services/map'
import { eventBus } from '@/services/utils'

export default {
  data () {
    return {
      transparency: 0,
      vectorLayers: []
    }
  },
  created () {
    eventBus.$on('map-created', () => {
      this.vectorLayers = getMap()
        .getLayers()
        .getArray()
        .filter(l => l.values_.type === 'reference')
        .map(l => {
          return { name: l.values_.name, visible: l.getVisible()
        }
      })
    })
  },
  methods: {
    toggleLegend,
    toggleLayer,
    onOpacityChange() {
      setOpacity(
        Math.abs(this.transparency - 100) / 100,
        this.vectorLayers
          .map((g) => {
            let lnames = [];
            lnames.push(g.name);
            return lnames;
          })
          .flat()
      );
    },
  }
}
</script>

<style lang="stylus">
  .reference-layers
    .v-input--selection-controls.v-input .v-label
      font-size: .9em
</style>

<style lang="stylus" scoped>
  .reference-layers
    padding 1em
    .heading
      display flex
      justify-content space-between
      align-items center
      margin-bottom 1em
      .legend
        color #004F27
        font-size .8em
    #layerList
      width auto
      margin-top 1em
      min-height 100px
    .layerList
      display flex
      flex-direction column
      align-items flex-start
      .v-input--checkbox
        margin 0 !important
        padding 0 !important
    .spacer
      background-color lightgrey
      height .1em
      margin-bottom 1em
    .btn.theme--light.secondary
      margin-left 0
    p
      margin-bottom 0
    .transparency-alert
      color #333
      padding 1em 1em 0 1em
      .input-group.input-group--slider
        padding 0
        margin-bottom -1em
        margin-top .5em
</style>
